import { NameValue } from '@unistocks/proxy/axios-client';
import { useTimeZoneSettingsGetTimezonesQuery } from '@unistocks/proxy/axios-client/TimeZoneSettingsQuery';
import { Option } from '@unistocks/types';
import { useCalendars } from 'expo-localization';

const selectTimeZoneOptions = (timeZones: NameValue[]): Option[] =>
  timeZones.map(timeZone => ({
    key: timeZone.name,
    value: timeZone.value
  }));

/**
 * @returns The time zones available in the application.
 */
export const useTimeZones = () =>
  useTimeZoneSettingsGetTimezonesQuery({
    select: selectTimeZoneOptions
  });

export const useSystemTimeZone = () => {
  return useCalendars()[0].timeZone;
};
